/**
 * @zendir/ui — Zendir Colour System (primitive palette)
 *
 * The raw Zendir brand scales, mirroring the Zendir Color System doc and
 * Figma exactly (same names, same order). These are Layer 0 primitives:
 * themes (src/tokens/themes.ts) and data-viz palettes reference these stops;
 * product code should consume semantic theme tokens, not these directly.
 *
 * "Neutral" is still labelled "Prussian Slate" in Figma — known naming
 * inconsistency, not fixed here.
 */

export const base = {
  white: "#FFFFFF",
  black: "#000000",
} as const;

export const electricBlue = {
  50: "#EEF2FF",
  100: "#E0E7FF",
  200: "#C4D2FF",
  300: "#9EB4FF",
  400: "#6F89FF",
  500: "#5061FF",
  600: "#3E3CFF",
  700: "#352EDF",
  800: "#2A2BB2",
  900: "#252E8A",
  950: "#151C50",
} as const;

export const prussianBlue = {
  50: "#EEF2FF",
  100: "#DEE7FE",
  200: "#C3D4FE",
  300: "#9BB6FF",
  400: "#698EFF",
  500: "#466AFC",
  600: "#2F4AF0",
  700: "#263DD3",
  800: "#1B2DA0",
  900: "#192B7A",
  950: "#0D1945",
} as const;

export const ultraviolet = {
  50: "#F5F3FD",
  100: "#EAE6FA",
  200: "#D8CFF9",
  300: "#C6B4FF",
  400: "#9D70FF",
  500: "#8744F3",
  600: "#7515E2",
  700: "#6600CD",
  800: "#5400AB",
  900: "#421182",
  950: "#251048",
} as const;

export const neutral = {
  50: "#F6F7FD",
  100: "#EDF2FC",
  200: "#DDE5F4",
  300: "#C8D1E6",
  400: "#8899BC",
  500: "#596B8E",
  600: "#445272",
  700: "#303C58",
  800: "#1B243D",
  900: "#0D1429",
  950: "#030414",
} as const;

/** All Zendir scales keyed by display name (drives Foundation/Palette). */
export const zendirScales = {
  Base: { White: base.white, Black: base.black },
  "Electric Blue": electricBlue,
  "Prussian Blue": prussianBlue,
  Ultraviolet: ultraviolet,
  // Labelled "Prussian Slate" to match Figma, where the Neutral ramp still
  // carries that name (known naming inconsistency, tracked in the palette doc).
  "Prussian Slate": neutral,
} as const;
